import angular from 'angular';
import constants from 'app/constants';
import {
  riskDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './approve-change-confirm-dialog.controller';
import template from './approve-change-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    changeType,
    changeEffects,
    change,
    changedIds,
    changesAreRecommended,
    newChanges,
    updateCallback
  }) {
    return {
      controller,
      controllerAs: 'approveChangeConfirmDialogVM',
      locals: {
        changeType,
        changeEffects,
        change,
        changedIds,
        changesAreRecommended,
        newChanges,
        updateCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.pm.approveChangeConfirmDialog', [
  alerts,
  riskDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('approveChangeConfirmDialog', dialogService)
  .name;
